export { default } from './BancoDoAutoMotoBannerF1';
